import React, { useEffect, useMemo, useRef, useState } from 'react'
import Tooltip from '@groovehq/internal-design-system/lib/components/Tooltip/Tooltip'
import Checkbox from '@groovehq/internal-design-system/lib/components/Checkbox/Checkbox'
import Avatar from '@groovehq/internal-design-system/lib/components/Avatar/Avatar'
import { styles } from '../MultiSelectMenu/styles'

export default function Option({ id, name, checked, avatarUrl }) {
  const [isItemTextOverflowing, setIsItemTextOverflowing] = useState(null)
  const itemTextRef = useRef(null)

  useEffect(() => {
    if (itemTextRef.current) {
      setIsItemTextOverflowing(
        itemTextRef.current.clientWidth < itemTextRef.current.scrollWidth
      )
    }
  }, [])

  const content = useMemo(
    () => (
      <div className="grui truncate" ref={itemTextRef}>
        <Avatar avatar={avatarUrl} userName={name} className="grui mr-5" />
        {name}
      </div>
    ),
    [name, avatarUrl]
  )

  return (
    <Checkbox css={styles.checkbox} truncate id={id} checked={checked}>
      {isItemTextOverflowing ? (
        <Tooltip title={name} strategy="fixed" portal="#overlays">
          {content}
        </Tooltip>
      ) : (
        content
      )}
    </Checkbox>
  )
}
